<div id="view_grid">
  <!-- Grid Details -->
  <div class="scroll_container">
    <table class="table_grid no_wrap">
            <thead>
                <tr class="header-row-min">
                    <th class="table_header">
                        <div class="table-header-inner">
                            <div class="header-text">
                                ID
                            </div>
                        </div>
                    </th>
                    <th class="table_header">
                        <div class="table-header-inner">
                            <div class="header-text">
                                Email
                            </div>
                        </div>
                    </th>
                    <th class="table_header">
                        <div class="table-header-inner">
                            <div class="header-text">
                                Logo
                            </div>
                        </div>
                    </th>
                    <th class="table_header">
                        <div class="table-header-inner">
                            <div class="header-text">
                                Select Logo
                            </div>
                        </div>
                    </th>
                    <th class="table_header" colspan="2">
                        <div class="table-header-inner">
                            <div class="header-text">
                                Actions
                            </div>
                        </div>
                    </th>
                    <!-- <th class="table_header footer-row">
                        <div class="table-header-inner">
                            <div class="header-text">

                            </div>
                        </div>
                    </th> -->
                        <!-- Add more headers if needed -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of users">
                    <td style="vertical-align: middle; position: relative;">{{ user?.id }}</td>
                    <td style="vertical-align: middle; position: relative;">{{ user?.email }}</td>
                    <td style="vertical-align: middle; position: relative;">
                        <img *ngIf="user?.logoName" [src]="storageUrl + user.logoName" [alt]="user.logoName || 'Logo'" style="height: 94px; width: auto; margin-right: 6px; vertical-align: middle; object-fit: contain;" />
                    </td>
                    <td style="vertical-align: middle; position: relative; min-height: 94px;">
                        <mat-form-field appearance="fill" class="logo-selector" style="min-height: 94px;">
                            <mat-label *ngIf="!user.selectedLogo">Select Logo</mat-label>
                            <mat-select [(ngModel)]="user.selectedLogo" [ngModelOptions]="{standalone: true}">
                                <mat-select-trigger>
                                    <ng-container *ngIf="user.selectedLogo; else noLogo">
                                        <span style="display: flex; align-items: center; min-height: 94px;">
                                            <img [src]="storageUrl + user.selectedLogo.name" [alt]="user.selectedLogo.name" style="height: 94px; width: auto; margin-right: 6px; vertical-align: middle; object-fit: contain;" />
                                            {{ user.selectedLogo.name }}
                                        </span>
                                    </ng-container>
                                    <ng-template #noLogo>No Logo</ng-template>
                                </mat-select-trigger>
                                <mat-option [value]="null">No Logo</mat-option>
                                <mat-option *ngFor="let logo of logos" [value]="logo">
                                    <span style="display: flex; align-items: center; min-height: 94px;">
                                        <img [src]="storageUrl + logo.name" [alt]="logo.name" style="height: 94px; width: auto; margin-right: 6px; vertical-align: middle; object-fit: contain;" />
                                    </span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                    <td style="vertical-align: middle; position: relative;">
                        <button class="btn_normal btn_purple" style="padding-left: 16px; padding-right: 16px; padding-top: 5px; padding-bottom: 5px;" (click)="applyChanges(user, user.selectedLogo)">Apply Changes</button>
                    </td>
                    <td colspan="5" class="footer-row" style="vertical-align: middle; position: relative;">
                        <button class="btn_normal btn_red" style="padding-left: 16px; padding-right: 16px; padding-top: 5px; padding-bottom: 5px;" (click)="applyChanges(user, null)">
                            <span class="icon-trash" aria-hidden="true" style="margin-right: 5px; vertical-align: middle; position: relative; top: 3px;">
                                <!-- Trash bin SVG icon -->
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 4H14M6 7V11M10 7V11M3 4V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V4M5 4V3C5 2.44772 5.44772 2 6 2H10C10.5523 2 11 2.44772 11 3V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            Remove logo
                        </button>
                    </td>
                </tr>
                <tr *ngIf="!users || users.length === 0">
                    <td colspan="3" class="no-users">No users found.</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
